import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  logError(message: string, stack?: string) {
    // format for console log
    const logFormat = 'background: maroon; color: white'

    // create message
    let msg = message
    if (stack) {
      msg += '\n'
      msg += 'Stack: ' + stack
    }

    // log to console
    // if (!environment.production) {
    console.log('%c ' + msg, logFormat)
    // }

    // TODO send to any server?
  }

  logSuccess(message: string) {
    // format for console log
    const logFormat = 'background: green; color: white'

    // log to console
    // if (!environment.production) {
    console.log(message, logFormat)
    // }

    // TODO send to any server?
  }

  logMessage(message: string) {
    // format for console log
    const logFormat = 'background: white; color: black'

    // log to console
    // if (!environment.production) {
    console.log(message, logFormat)
    // }

    // TODO send to any server?
  }
}
